import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginComp.css";
import InputComp from "../InputComp/InputComp";

const LoginComp = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  
  const navigate = useNavigate(); // For navigation

  // Handle input change
  const handleInput = (e) =>
    setData({ ...data, [e.target.name]: e.target.value });

  // Login function
  const handleLogin = (e) => {
    e.preventDefault();

    // Retrieve stored data from localStorage
    const storedEmail = localStorage.getItem("userEmail");
    const storedPassword = localStorage.getItem("userPassword");

    // Check if entered data matches stored data
    if (data.email === storedEmail && data.password === storedPassword) {
      alert("Login successful!");
      navigate("/dashboard"); // Navigate to the dashboard
    } else {
      alert("Invalid email or password. Please try again.");
    }
  };

  const registerbtn = (e) => {
    navigate("/register"); 

  }

  return (
    <div className="login-comp">
      <div className="center">
        <InputComp
          label="Email"
          inputHandler={handleInput}
          placeholder="Enter your email..."
          value={data.email}
          name="email"
          type="text"
        />
        <InputComp
          label="Password"
          inputHandler={handleInput}
          placeholder="Enter your password..."
          name="password"
          value={data.password}
          type="password"
        />
        <div className="buttons">
          <button onClick={handleLogin} className="mui-button">Login</button>
          <button onClick={registerbtn} className="mui-button">Register</button>
        </div>
      </div>
    </div>
  );
};

export default LoginComp;
